import api from '../../services/api';

// What the Apps page and an app's own page both read.

// The shelves: the developer's choice, on the app itself (migration 277).
export { SHELVES, shelfOf } from '../../components/nucleus/shelves';

// The price as the server rendered it — never formatted here — only shortened
// for a cell's corner, as the Mac does ("$6 / month" → "$6/mo").
export function priceOf(app) {
    const d = app?.pricing_display;
    if (!d || !d.is_paid || !d.headline) return null;
    return d.headline;
}
export const shortPrice = (p) => p.replace(/\s*\/\s*month/i, '/mo').replace(/\s*\/\s*year/i, '/yr');

// What this space approved: active rows of /app-shell/apps, one per app.
export async function loadApproved(groupId) {
    const q = groupId ? `?group_id=${encodeURIComponent(groupId)}` : '';
    const r = await api.request(`/app-shell/apps${q}`).catch(() => null);
    return (r?.apps || []).filter((row) => row?.app?.id);
}


// THE CATALOG AS THIS SPACE SEES IT. The records (price, DLR, website) are
// /apps's; in a group the set is the group's (/groups/<id>/apps, as the old
// group tab read it), and nothing is "yours" — a purchase belongs to whoever
// paid, and the viewer's own does not cover the group. (Checkout answers
// already_purchased itself when the group did pay.)
export async function loadCatalog(groupId) {
    const all = await api.request('/apps').then((r) => r?.apps || []).catch(() => []);
    if (!groupId) return all;
    const g = await api.request(`/groups/${groupId}/apps`).catch(() => null);
    const ids = new Set([...(g?.apps || []), ...(g?.available_apps || [])].map((a) => String(a.id)));
    return all
        // a group with no realms yet answers with nothing: keep the whole catalog
        .filter((a) => !ids.size || ids.has(String(a.id)))
        .map((a) => ({ ...a, is_purchased: false, is_authorized: undefined, authorization_id: undefined }));
}

// THE AGENTS AN APP RUNS IN THIS SPACE: its sub-entity grants, which
// /app-shell/apps leaves out (sub_entity_key IS NULL). Both lists carry paused
// grants (a paused agent shows, to be resumed); revoked ones are dropped here.
export async function loadAgentGrants(groupId, appId) {
    const r = await api.request(groupId ? `/groups/${groupId}/exposure-profiles` : '/exposure-profiles?entity_type=app').catch(() => null);
    return (r?.exposure_profiles || []).filter((ep) => ep && ep.entity_type === 'app' && ep.sub_entity_key
        && !ep.revoked_at && String(ep.entity_id) === String(appId));
}

// The grant an app holds here, active first, then paused; expired is gone.
export function standingOf(rows) {
    const live = rows.filter((r) => (r.ep?.status || 'active') !== 'expired');
    return live.find((r) => (r.ep?.status || 'active') === 'active') || live.find((r) => r.ep?.status === 'paused') || null;
}
